import axios from 'axios';
import { PREFIX_URL } from './config';
import { generateRoutePath } from '../routes';

const URLS = {}

URLS.BASE_URL = `${PREFIX_URL}/tasks/:taskId`;
URLS.SAVE_STATUS = `${URLS.BASE_URL}/action`;
URLS.SAVE_STATUS_COMPLETED = `${URLS.BASE_URL}/complete`;


export const saveStatus = (taskId, params) => {
    const url = generateRoutePath(URLS.SAVE_STATUS, {taskId} )

    return axios.put(url, params);
}

export const saveStatusComplete = (taskId) => {
    const url = generateRoutePath(URLS.SAVE_STATUS_COMPLETED, {taskId} )

    return axios.post(url);
}